import { createRouter, createWebHistory } from "vue-router"; // Import createWebHistory
import HomeView from "../views/HomeView.vue";
import ContactsView from "../views/Contacts.vue";
import AboutCyprusView from "../views/AboutCyprus.vue";
import PrivacyPolicyView from "../views/PrivacyPolicy.vue";
import CarsView from "@/views/CarsView.vue";
import CarRequestView from "@/views/CarRequestView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/contacts",
    name: "Contacts",
    component: ContactsView,
  },
  {
    path: "/cars",
    name: "Cars",
    component: CarsView,
  },
  {
    path: "/about-cypr",
    name: "About Cyprus",
    component: AboutCyprusView,
  },
  {
    path: "/privacy",
    name: "Privacy Policy",
    component: PrivacyPolicyView,
  },
  {
    path: "/carrequest",
    name: "CarRequestView",
    component: CarRequestView,
  },
];

const router = createRouter({
  history: createWebHistory(), // Use createWebHistory for history mode
  routes,
});

export default router;
